import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    gridTemplateColumns: '2fr 3fr',
    gridTemplateRows: '1fr auto 1fr',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      height: 'auto',
      minHeight: '100vh',
      gridTemplateRows: 'none',
    },
  },
  leftBox: {
    gridColumn: 1,
    gridRow: '1 / 4',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'subgrid',
    justifyItems: 'center',
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(0, 6),
    borderRadius: '0 32px 32px 0',
    '& > *': {
      gridRow: 2,
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'auto',
      padding: theme.spacing(6, 4),
      borderRadius: '0 0 24px 24px',
      '& > *': {
        gridRow: 'auto',
      },
    },
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(5),
  },
  logo: {
    width: 220,
    height: 'auto',
  },
  welcomeText: {
    color: theme.palette.primary.contrastText,
    fontFamily: 'Raleway',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.5,
    letterSpacing: 0,
    textAlign: 'left',
    opacity: 0.9,
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      textAlign: 'center',
    },
  },
  wrapper: {
    gridColumn: 2,
    gridRow: '1 / 4',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'subgrid',
    justifyItems: 'center',
    padding: theme.spacing(0, 6),
    '& > *': {
      gridRow: 2,
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      height: 'auto',
      padding: theme.spacing(6, 4),
      '& > *': {
        gridRow: 'auto',
      },
    },
  },
}))

export default useStyles
